import React from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Tooltip from "@mui/material/Tooltip";
import Popover from "@mui/material/Popover";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const InfoWithMobilePopover = ({ description }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    if (isMobile) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (isMobile) {
    return (
      <>
        <IconButton onClick={handleClick} size="small" aria-label="info">
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          PaperProps={{ style: { padding: 12, maxWidth: 260 } }}
        >
          <Typography variant="body2">{description}</Typography>
        </Popover>
      </>
    );
  }

  return (
    <Tooltip
      title={description}
      arrow
      enterTouchDelay={0}
      leaveTouchDelay={4000}
    >
      <IconButton size="small" aria-label="info">
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default InfoWithMobilePopover;
